import React, {useState} from "react";
import {
    IonApp, IonPage, IonToolbar, IonButtons, IonMenuToggle, IonButton, IonContent, IonBreadcrumb,IonBreadcrumbs, IonGrid,IonRow,IonCol
  } from "@ionic/react";

import UserLogout from "../../../components/UserLogoutComponent"
import PaymentMehtods from "./PaymentMethods";
import PaymentSummary from "./PaymentSummary";
import { useHistory } from "react-router-dom";

function PaymentComponent(props) {
    let history = useHistory();
    const [validPaymentMethodSelected , setValidPaymentMethodSelected] = useState(true)

    return (
        <>
             <IonApp>
                <IonPage className="ion-page core-wrapper" id="main-content">
                    <IonToolbar className="header-toolbar">
                        <IonButtons slot="start" className="home-btn">
                            <IonMenuToggle>
                                <IonButton>
                                    <img src="../img/menu-icon.png" />
                                </IonButton>
                            </IonMenuToggle>
                        </IonButtons>
                        <img className="header-logo" src="../img/logo.png" />
                    </IonToolbar>

                    <IonContent className="ion-padding page-title">
                        <div className="wrapper dashboard-page  option-1 option-1-1">
                            <IonBreadcrumbs>
                                <IonBreadcrumb href="new-delivery">
                                    New Delivery
                                </IonBreadcrumb>
                                <IonBreadcrumb href="">Payments</IonBreadcrumb>
                            </IonBreadcrumbs>
                            <h1>Make Payment</h1>
                            
                            <div className="payment desktop">
                                <img src="../img/payment.svg" />
                            </div>
                            <div className="payment mobile">
                                <img src="../img/payment.svg" />
                            </div>
                            
                            <PaymentSummary/>
                            <PaymentMehtods validPaymentMethodSelected={validPaymentMethodSelected}  setValidPaymentMethodSelected={setValidPaymentMethodSelected} />

                            <IonGrid>
                                <IonRow>
                                    <IonCol className="payment-next back ion-align-self-end left">
                                        <IonButton size="default"  mode='ios' onClick={()=>{
                                            history.push("/booking")
                                        }}>Back</IonButton>
                                    </IonCol>

                                    <IonCol className="payment-next ion-align-self-end right">
                                        <IonButton color="primary" size="default" disabled={validPaymentMethodSelected} mode='ios' href="/confirm">Next</IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>

                        </div>
                    </IonContent>
                
                </IonPage>
             </IonApp>
        </>
    )
}

export default PaymentComponent;